import { fetchDataPromise } from '../index';

export const getRoleDetail = (resolve, reject, token, roleSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/getroledetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: roleSeq
    })
  });

  fetchDataPromise(req, 'getRoleDetail', resolve, reject);
}

export const removeRole = (resolve, reject, token, roleSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/deleterole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: roleSeq
    })
  });

  fetchDataPromise(req, 'removeRole', resolve, reject);
}

export const addRole = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/addrole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'addRole', resolve, reject);
}

export const editRole = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/editrole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'editRole', resolve, reject);
}